import { string } from 'prop-types';
import React from 'react';

function LightningBolt({ fill, ...props }) {
  return (
    <svg
      fill="none"
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0737 1.55145L6.65205 12.2189C6.57953 12.3233 6.53015 12.4562 6.51015 12.6009C6.49015 12.7456 6.50044 12.8955 6.5397 13.0318C6.57896 13.1681 6.64544 13.2846 6.73074 13.3667C6.81605 13.4487 6.91635 13.4925 7.01898 13.4926H9.92671V22.4485L17.3483 11.7811C17.4209 11.6767 17.4702 11.5438 17.4902 11.3991C17.5102 11.2544 17.5 11.1044 17.4607 10.9682C17.4214 10.8319 17.355 10.7154 17.2696 10.6333C17.1843 10.5513 17.084 10.5075 16.9814 10.5073H14.0737V1.55145Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

LightningBolt.propTypes = {
  fill: string.isRequired
};

export default LightningBolt;
